import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link/Link';

type InvalidUrlComponentProps = {
  message: string;
  href: string;
};

const InvalidUrlComponent = ({ message, href }: InvalidUrlComponentProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        margin: '0 auto',
        minHeight: 'calc(100% - 150px)',
        maxWidth: 1295,
        textAlign: 'center',
        height: '100vh'
      }}
    >
      <Box>
        <Box pt={5} pb={2}>
          <Typography
            gutterBottom
            variant="h4"
            component="h1"
            data-testid="invalid-url-message"
            noWrap
          >
            {message}
          </Typography>
          <Box display="flex" flexDirection="row" justifyContent="center">
            <Typography
              component="span"
              noWrap
              data-testid="invalid-url-subMessage"
            >
              Go <Link href={href}>back</Link>
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default InvalidUrlComponent;
